import { gql } from '@apollo/client';

export const READ_HSL_TICKET_RENDER = gql`
  query ReadHslTicketRender($input: HslTicketRenderInput!) {
    readHslTicketRender(input: $input) {
      ticket
    }
  }
`;
